import React from "react";
import BaseTextInput, { type TBaseTextInputProps } from "../baseTextInput";
interface IBaseCarplateTextInput {
  onChangeCarplate: (carplate: string) => void;
}

type TBaseCarplateTextInputProps = IBaseCarplateTextInput & TBaseTextInputProps;

const BaseCarplateTextInput: React.FC<TBaseCarplateTextInputProps> = (
  props
) => {
  const { onChangeCarplate, ...otherProps } = props;

  const customOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[A-Z0-9]{0,8}$/;
    const upperCarPlate = e.target.value.toUpperCase();
    const formattedCarPlate = upperCarPlate
      .replaceAll("I", "")
      .replaceAll("O", "")
      .replaceAll("Q", "");

    if (regex.test(formattedCarPlate)) {
      onChangeCarplate(formattedCarPlate);
    }
  };

  return (
    <BaseTextInput
      placeholder="車牌號碼"
      required
      maxLength={8}
      onChange={customOnchange}
      {...otherProps}
    />
  );
};

export default BaseCarplateTextInput;
